// extracted by mini-css-extract-plugin
export default {"loaderPanel":"LoaderPanel_loaderPanel__yve-c","active":"LoaderPanel_active__9Jwp-","loader":"LoaderPanel_loader__ne+1J","l3":"LoaderPanel_l3__jvEGX"};